module.exports = __webpack_public_path__ + "img/909024-55-1.55ddb5ac.png";